import React from 'react';



const Buyoncampusbuy = () => {
   
  

  return (
    <div className='container'>
        <div className='text-xl'><strong>Buy on Campusify</strong></div>
        <div className='mt-4'>
        <ul>
            <li className='my-3'>Type in your school and choose it on the homepage</li>
        <li className='my-3'>Search for your Product on the search bar</li>
        <li className='my-3'>Click on the product you want to buy.</li>
        <li className='my-3'>Contact the seller via the seller information.</li>
        <li className='my-3'>Meet the seller in a public place and do business.</li>
        </ul>
        </div>
    </div>
  )
}

export default Buyoncampusbuy